import { setPacketaPoint, setPacketaWidget } from './Packeta.action';

/**
 * AmazonPayPayment Dispatcher
 * @class PayPalPaymentDispatcher
 * @namespace Bodymod/Packeta/Store/Packeta/Dispatcher */
export class PacketaDispatcher {
    setPacketaPoint(point, dispatch) {
        dispatch(setPacketaPoint(point));
    }

    setPacketaWidget(isSet, dispatch) {
        dispatch(setPacketaWidget(isSet));
    }
}

export default new PacketaDispatcher();
